import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cdate'
})
export class CdatePipe implements PipeTransform {

  transform(value: Date,field:any): any {
    if(field.locale!=undefined){
      return value.toLocaleDateString(field.locale,field.options)
    }else{

      let language = window.navigator.language || window.navigator.language;

      return value.toLocaleDateString(language,field.options)
    }

    // value.getDate()+' / '+(value.getMonth()+1)+' / '+value.getFullYear();
  }

}
